import './utils/embeddable.scss';
import React from 'react';
import {bindActionCreators} from 'redux';
import {Col, Container, Pagination, PaginationItem, PaginationLink, Row, Spinner} from 'reactstrap';
import * as actions from './EmbeddableApi';
import PropTypes from 'prop-types';
import ResourceComponent from '../../common/ResourceComponent';
import EmbSlabModal from './utils/EmbSlabModal';
import {getPublicUrl} from '../../common/AppContextTools';
import EmbSubmitModal from './EmbSubmitModal';
import MobileMenu from './utils/MobileMenu';
import DesktopMenu from './utils/DesktopMenu';
import {connect} from 'react-redux';
import EmbFilters from './utils/EmbFilters';
import EmbSlabItem from './EmbSlabItem';
import EmbBundleItem from './EmbBundleItem';
import EmbLumberItem from './EmbLumberItem';
import EmbBundleModal from './utils/EmbBundleModal';
import SubmitClaimModal from './utils/SubmitClaimModal';
import ClaimedItemsBar from './utils/ClaimedItemsBar';
import * as _ from 'lodash';
import {getBackgroundColor, reverseColor} from '../../common/Utils';
import axios from 'axios';
import ReactGA from 'react-ga4';
import EmbIndustrialPackItem from './EmbIndustrialPackItem';
import EmbIndustrialPackModal from './utils/EmbIndustrialPackModal';
import SurveyModal from './SurveyModal';
import EmbLumberModal from './utils/EmbLumberModal';

class EmbPage extends ResourceComponent {
    per_page = 20;
    state = {
        items: [],
        item: null,
        pagesCount: 0,
        filters: {
            characters: [],
            categories: [],
            tags: [],
            gradings: [],
            trees: [],
            locations: [],
            cycles: [],
            number: null,
            type: '',
            sort_by: 'newest',
            page: 1,
            price: {min: 0, max: 0},
            avg_board_length: {min: 0, max: 0},
            surfaced_thickness: {min: 0, max: 0},
            thickness: {min: 0, max: 0},
            length: {min: 0, max: 0},
            rows: {min: 0, max: 0},
            width_minimum: {min: 0, max: 0},
            width_maximum: {min: 0, max: 0},
            width: {min: 0, max: 0},
            total_bf: {min: 0, max: 0},
        },
        clientInformation: {
            customerLogoUrl: '',
            phoneNumber: null,
            website: '',
        },
        settings: {
            main_default_pic_url: null,
            slab_default_pic_url: null,
            card_container_color: null,
            left_container_color: null,
            main_container_color: null,
            banner_color_index: null,
            font_color_index: null,
            banner_color: null,
            font_color: null,
            sanding_cost: null,
            sanding_cost_with_fee: null,
            surfacing_cost: null,
            surfacing_cost_with_fee: null,
            map_style: null,
            picture_url: null,
            show_main_photo: false,
            show_color_block: false,
            ordered_message: null,
            rotate_images: true,
            sticky_header: true,
            sticky_footer: true,
            show_empty_menu_item: true,
            recaptcha: true,
            shipping: true,
            card_detail: {
                tree_name_index: true,
                number_index: true,
                thickness_index: true,
                surfaced_thickness_index: true,
                min_width_index: true,
                board_feet_index: true,
                bf_price_index: true,
                length_index: true,
                price_index: true,
                location_index: true,
                max_width_index: true,
                discount_label_index: true,
                sale_discount_index: true,
                show_images_index: true,
                price_font_size_index: 22,
                discount_font_size_index: 26,
                banner_transparency: 1,
                story: true,
                characters: true,
                number: true,
                description: true,
                tree_name: true,
                show_images: true,
                status: true,
                min_width: true,
                speciality: true,
                category: true,
                location: true,
                max_width: true,
                sanded: true,
                thickness: true,
                surfaced_thickness: true,
                length: true,
                surfaced: true,
                diameter: true,
                board_feet: true,
                discount_label: true,
                sale_discount: true,
                price: true,
                bf_price: true,
                images: true,
                removal_date: true,
                map: true,
                address: true,
                description_card: true,
                label: true,
                discount_label_left: true,
                image_size: 1,
            },
            bundle_card_detail: {
                source_type_index: true,
                carbon_smart_wood_index: true,
                species_index: true,
                number_index: true,
                thickness_index: true,
                board_feet_index: true,
                min_board_width_index: true,
                min_board_length_index: true,
                avg_board_length_index: true,
                price_index: true,
                board_ft_price_index: true,
                location_index: true,
                images_index: true,
                price_font_size_index: 26,
                sale_discount_index: 22,
                discount_font_size_index: 26,
                banner_transparency_index: 1,
                source_type: 1,
            },
        },
        modal: false,
        submitModal: false,
        settingsReady: false,
        ready: false,
        loading: true,
        square_connect_status: false,
        stripe_connect_status: false,
        hide_filters: false,
        stripe_api_key: '',
        client_id: null,
        filter: false,
        filter_id: null,
        showSubmitClaimModal: false,
        transaction_preferences: {transaction_option: 'None', material_type: []},
        showSurveyModal: false,
    };

    constructor() {
        super();
        this.submitClaimModalRef = React.createRef();
    }

    componentDidMount() {
        async function getGAKey() {
            const publicUrl = getPublicUrl();
            if (publicUrl) {
                const config = {
                    url: '/profile/ga_key',
                    params: {public_url: publicUrl},
                    errorMessage: 'Something went wrong while loading Client GA key',
                };
                const result = await axios.request(config);
                return result.data.ga_key;
            } else {
                return null;
            }
        }

        async function initializeGA() {
            const gaKey = await getGAKey();

            if (gaKey) {
                ReactGA.initialize(gaKey);

            } else {
                console.log('GA key not available');
            }
        }

        initializeGA();

        if (window.location.href.includes('item_id')) {
            const urlParams = window.location.search.substring(1).split('&');
            const itemId = urlParams.find(p => p.includes('item_id')).split('=')[1];
            if (window.location.href.includes('slabs')) {
                this.onSlabClick(itemId);
            } else if (window.location.href.includes('bundles')) {
                this.onBundleClick(itemId);
            } else if (window.location.href.includes('lumbers')) {
                this.onLumberClick(itemId);
            } else if (window.location.href.includes('industrial_packs')) {
                this.onIndustrialPackClick(itemId);
            }
            const cleanUrl = window.location.href.split('?')[0];
            history.replaceState({}, '', cleanUrl);
        }

        const publicUrl = getPublicUrl();
        this.props.actions.getClientInfo(publicUrl, null, [], profile => {
            if (profile.feature_flags.find(ff => ff.name === 'Embed Survey')) {
                this.props.actions.checkIfSurveyAlreadyAnswered({client_id: profile.client_id}, ({answered}) => {
                    this.setState({showSurveyModal: !answered});
                });
            }
        });

        const currentPathname = this.props.history.location.pathname;
        let itemTypeFromPathname = currentPathname.replace('embedded_', '').split('/')[1];
        if (itemTypeFromPathname !== this.state.filters.type) {
            this.setState({filters: {...this.state.filters, type: itemTypeFromPathname}});
        }

        this.loadSettings();
    }

    sendEventData = (event_name, params) => {
        ReactGA.gtag('event', event_name, params);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.settingsReady && this.state.settingsReady !== prevState.settingsReady) {
            const filterId = window.location.href.includes('filter') ? window.location.href.split('filter=')[1] : null;
            if (filterId) {
                this.props.actions.getFilter(filterId, (result) => {
                    if (result.should_redirect) {
                        return window.location.replace(window.location.href.split('filter=')[0]);
                    }
                    this.setState({itemType: result.category}, () => this.search({
                        initial: true,
                        sort_by: this.getSortBy(this.state.settings.page_order),
                    }));
                });
            } else {
                this.search({sort_by: this.getSortBy(this.state.settings.page_order)});
            }
        }

        const currentPathname = this.props.history.location.pathname;
        if (this.state.filters.type && prevState.filters.type !== this.state.filters.type && !currentPathname.includes(this.state.filters.type)) {
            const newPathname = `/${this.state.filters.type.toLowerCase()}`;
            this.props.history.push(newPathname);
        }

        if (this.state.showSubmitClaimModal && !prevState.showSubmitClaimModal && this.submitClaimModalRef.current) {
            this.submitClaimModalRef.current.scrollIntoView({behavior: 'smooth'});
        }
    }

    getSortBy = (page_order) => {
        if (page_order === 'Lowest price') {
            return 'price_low';
        } else if (page_order === 'Highest price') {
            return 'price_high';
        } else if (page_order === 'Sale items') {
            return 'sales';
        } else {
            return page_order.toLowerCase();
        }
    };

    prepareParams = (filters = null) => {
        let params = {...filters};
        params.character_ids = filters.characters ? filters.characters.map(n => n.value) : [];
        params.category_ids = filters.categories ? filters.categories.map(n => n.value) : [];
        params.tag_ids = filters.tags ? filters.tags.map(n => n.value) : [];
        if (filters.type === 'industrial_packs') {
            params.grading_ids = filters.gradings ? filters.gradings.map(n => n.value) : [];
            params.total_bf_min = filters.available_bf ? filters.available_bf.min : null;
            params.total_bf_max = filters.available_bf ? filters.available_bf.max : null;
        } else {
            params.total_bf_min = filters.total_bf ? filters.total_bf.min : null;
            params.total_bf_max = filters.total_bf ? filters.total_bf.max : null;
        }
        params.location_ids = filters.locations ? filters.locations.map(n => n.value) : [];
        params.cycle_ids = filters.cycles ? filters.cycles.map(n => n.value) : [];
        params.tree_ids = filters.species ? filters.species.map(n => n.value) : [];
        params.number = filters.number ? filters.number.value : null;
        params.type = filters.type;

        params.price_min = filters.price.min;
        params.price_max = filters.price.max;
        params.avg_board_length_min = filters.avg_board_length ? filters.avg_board_length.min : null;
        params.avg_board_length_max = filters.avg_board_length ? filters.avg_board_length.max : null;
        params.surfaced_thickness_min = filters.surfaced_thickness ? filters.surfaced_thickness.min : null;
        params.surfaced_thickness_max = filters.surfaced_thickness ? filters.surfaced_thickness.max : null;
        params.thickness_min = filters.thickness ? filters.thickness.min : null;
        params.thickness_max = filters.thickness ? filters.thickness.max : null;
        params.rows_min = filters.rows ? filters.rows.min : null;
        params.rows_min = filters.rows ? filters.rows.max : null;
        params.width_minimum_min = filters.width_minimum ? filters.width_minimum.min : null;
        params.width_minimum_max = filters.width_minimum ? filters.width_minimum.max : null;
        params.width_maximum_min = filters.width_maximum ? filters.width_maximum.min : null;
        params.width_maximum_max = filters.width_maximum ? filters.width_maximum.max : null;
        params.length_min = filters.length ? filters.length.min : null;
        params.length_max = filters.length ? filters.length.max : null;
        params.width_min = filters.width ? filters.width.min : null;
        params.width_max = filters.width ? filters.width.max : null;

        return params;
    };

    onFilterSelect = (filters, callback = () => {
    }) => {
        filters = {...filters, page: this.state.filters.page};
        this.setState({loading: true, filters}, () => {
            this.search({sort_by: this.getSortBy(this.state.settings.page_order)}, callback);
            this.loadSettings();
        });
    };

    onSliderChange = (filters) => {
        this.setState({filters: {...this.state.filters, ...filters}, loading: true}, () => {
            this.search(null);
            this.loadSettings();
        });
    };

    loadSettings = () => {
        const publicUrl = getPublicUrl();
        if (publicUrl) {
            const {filters} = this.state;

            let ids = [];
            let type = 'all';
            if (filters.trees.length) {
                ids = filters.trees.map(x => x.value);
                type = 'tree';
            } else if (filters.categories.length) {
                ids = filters.categories.map(x => x.value);
                type = 'category';
            } else if (filters.gradings && filters.gradings.length) {
                ids = filters.gradings.map(x => x.value);
                type = 'grading';
            } else if (filters.locations.length) {
                ids = filters.locations.map(x => x.value);
                type = 'location';
            } else if (filters.cycles.length) {
                ids = filters.cycles.map(x => x.value);
                type = 'cycle';
            }

            this.props.actions.getClientInfo(publicUrl, type, ids, profile => {
                if (profile) {
                    const {
                        transaction_preferences,
                        stripe_connect_status,
                        square_connect_status,
                        client_id,
                        page_order,
                        hide_filters,
                    } = profile;
                    if (stripe_connect_status) {
                        this.props.actions.getApiKey(client_id, res =>
                            this.setState({stripe_api_key: res.apiKey}));
                    }
                    profile.square_connect_status && this.props.actions.getSquareCredentials(profile.client_id, res =>
                        this.setState({
                            square_application_id: res.application_id,
                            square_location_id: res.location_id,
                            sandbox: res.sandbox,
                        }),
                    );

                    this.setState({
                        transaction_preferences,
                        stripe_connect_status,
                        square_connect_status,
                        client_id,
                        hide_filters,
                        clientInformation: {
                            customerLogoUrl: profile.customer_logo_url,
                            phoneNumber: profile.client.phone_number,
                            website: profile.client.website,
                        },
                        settingsReady: true,
                        settings: {...this.state.settings, ...profile},
                    });
                }
            });
        }
    };

    countPages = () => {
        const {total_entries} = this.state.items;
        const totalPages = Math.ceil(total_entries / this.per_page);
        this.setState({pagesCount: totalPages});
    };

    search = (additionalParams = null, callback = () => {
    }) => {
        const {filters, settings, itemType} = this.state;
        const params = additionalParams ? {...this.prepareParams(filters), ...additionalParams} : this.prepareParams(filters);
        const type = ((additionalParams && additionalParams.initial) ? itemType : params.type ? params.type : settings.default_item_type.toLowerCase() || 'slabs');

        this.setState({loading: true});
        if (type) {
            const filterId = window.location.href.includes('filter') ? window.location.href.split('filter=')[1] : null;
            this.setState({filter_id: filterId});
            params.filter_id = filterId;
            params.type = type;
            this.props.actions.loadResources({filters: params}, type, ({
                                                                           items,
                                                                           trees,
                                                                           categories,
                                                                           tags,
                                                                           gradings,
                                                                           locations,
                                                                           characters,
                                                                           cycles,
                                                                       }) => {
                this.setState({
                    items,
                    categories,
                    tags,
                    gradings,
                    locations,
                    characters,
                    cycles,
                    ready: true,
                    filters: {...filters, type, sort_by: additionalParams ? additionalParams.sort_by : filters.sort_by},
                }, () => {
                    this.setState({loading: false});
                    callback();
                    this.countPages();
                });
            });
        }
    };

    onSlabClick = (slabId) => {
        this.props.actions.getSlab(slabId, item => this.setState({item: {...item, type: 'Slab'}, modal: true}));
    };

    onBundleClick = (bundleId) => {
        this.props.actions.getBundle(bundleId, item => this.setState({item: {...item, type: 'Pack'}, modal: true}));
    };

    onLumberClick = (lumberId) => {
        this.props.actions.getLumber(lumberId, item => this.setState({item: {...item, type: 'Lumber'}, modal: true}));
    };

    onIndustrialPackClick = (packId) => {
        this.props.actions.getIndustrialPack(packId, item => this.setState({
            item: {...item, type: 'Industrial Pack'},
            modal: true,
        }));
    };

    openSubmitModal = () => {
        this.setState({submitModal: true});
    };

    closeSubmitModal = () => {
        this.state.items.content.forEach(s => {
            s.request_sanded = undefined;
            s.request_surfaced = undefined;
        });
        this.setState({submitModal: false}, this.search);
    };

    closeModal = () => {
        this.setState({modal: false, item: null});
    };

    changeSort = (sortType) => {
        this.setState({filters: {...this.state.filters, sort_by: sortType}}, this.search);
    };

    onClaim = (item) => {
        item.number = item.number ? item.number : item.inventory_number;
        this.props.actions.addClaimedItem(item);
        this.sendEventData('add_to_cart', {
            currency: 'USD',
            value: item.price,
            items: [{
                item_name: `${item.type}: ${item.number}`,
                price: item.price,
            }],
        });
        this.setState({showSubmitClaimModal: true});
    };

    onUnclaim = (item) => {
        item.number = item.number ? item.number : item.inventory_number;
        this.props.actions.removeClaimedItem(item.id);
        this.sendEventData('remove_from_cart', {
            currency: 'USD',
            value: item.price,
            items: [{
                item_name: `${item.type}: ${item.number}`,
                price: item.price,
            }],
        });
        const removingLastItem = this.props.claimedItems.length === 1;
        if (!removingLastItem) {
            this.setState({showSubmitClaimModal: true});
        }
    };

    checkClaimed = (item) => {
        const {claimedItems} = this.props;
        return claimedItems.find(x => x.id === item.id);
    };

    getItemRange = () => {
        const {size = 0, per_page, current_page} = this.state.items;
        if (size === per_page) {
            const itemRange = (per_page * current_page) || 0;
            return `${itemRange - per_page + 1} - ${itemRange}`;
        } else {
            const itemRange = (per_page * (current_page - 1) + size) || 0;
            if (current_page === 1) {
                return `${itemRange - size + 1} - ${itemRange}`;
            } else {
                return `${itemRange - size} - ${itemRange}`;
            }
        }
    };

    getItemType = type => {
        switch (type) {
            case 'slabs':
                return 'SLABS';
            case 'bundles':
                return 'PACKS';
            case 'industrial_packs':
                return 'INDUSTRIAL PACKS';
            case 'lumbers':
                return 'BOARDS AND BEAMS';
            default:
                return '';
        }

    };

    formatAvailableInventory = (elements) => {
        const {filters, settings} = this.state;
        const filtersType = this.getItemType(filters.type);
        const type = filters.type ? filtersType : settings.default_item_type;
        return type + ' - ' + elements.map(c => c.label.toUpperCase()).join(', ');
    };

    setAvailableInventory = () => {
        const {filters, settings} = this.state;
        let availableInventory = null;
        const type = this.getItemType(filters.type);
        if (filters.trees.length) {
            availableInventory = this.formatAvailableInventory(filters.trees);
        } else if (filters.categories.length) {
            availableInventory = this.formatAvailableInventory(filters.categories);
        } else if (filters.tags.length) {
            availableInventory = this.formatAvailableInventory(filters.tags);
        } else if (filters.gradings && filters.gradings.length) {
            availableInventory = this.formatAvailableInventory(filters.gradings);
        } else if (filters.locations.length) {
            availableInventory = this.formatAvailableInventory(filters.locations);
        } else if (filters.cycles.length) {
            availableInventory = this.formatAvailableInventory(filters.cycles);
        } else {
            availableInventory = filters.type ? type : settings.default_item_type;
        }
        return availableInventory;
    };

    isActive = (routeName) => {
        const currPath = this.props.location.pathname;
        return currPath === routeName;
    };

    toggleFilter = () => {
        this.setState({filter: !this.state.filter});
    };

    getItemsContainerPaddingBottom = () => {
        let paddingBottom = 0;
        if (this.state.settings.sticky_footer) {
            paddingBottom += 70;
        }
        if (this.props.claimedItems.length > 0) {
            paddingBottom += 50;
        }
        return paddingBottom;
    };

    getSelectablePages = () => {
        const {pagesCount, filters} = this.state;
        const currentPage = filters.page;
        const currentMinPage = _.max([currentPage - 2, 1]);
        const currentMaxPage = _.min([currentPage + 2, pagesCount]);
        return _.range(currentMinPage, currentMaxPage + 1);
    };

    resetFilters = (initialFilters, callback) => {
        const resetFilters = {
            ...initialFilters,
            page: 1,
            sort_by: this.state.filters.sort_by || this.state.settings.page_order,
        };
        this.setState({filters: resetFilters}, () => {
            this.search({sort_by: this.getSortBy(this.state.filters.sort_by)});
            callback && callback();
        });
    };

    render() {
        const {
            items,
            filters,
            ready,
            tree,
            item,
            modal,
            pagesCount,
            settings,
            submitModal,
            filter,
            stripe_connect_status,
            square_connect_status,
            itemType,
            loading,
            hide_filters,
            showSubmitClaimModal,
            settingsReady,
            clientInformation,
            cycles,
            categories,
            tags,
            gradings,
            locations,
            characters,
            transaction_preferences,
        } = this.state;
        const {claimedItems} = this.props;
        const {card_detail, bundle_card_detail} = settings;
        const backgroundColor = getBackgroundColor(settings.left_container_color);
        const color = reverseColor(backgroundColor);
        const paginationLinkStyle = {backgroundColor, color, borderColor: 'transparent'};
        const showClaimedItemsBar = claimedItems.length > 0 && !modal && !submitModal;
        const claimEnabled = transaction_preferences.transaction_option === 'Claim';
        const ecommerceConnected = (stripe_connect_status || square_connect_status) && transaction_preferences.transaction_option === 'Direct Purchase';
        const materialType = transaction_preferences.material_type;

        const adjustHeightParams = [showClaimedItemsBar, settings.show_logo_and_contact];
        const adjustFiltersHeight = () => {
            if (settings.sticky_header) {
                const trueParamsLength = adjustHeightParams.filter(param => param === true).length;
                if (trueParamsLength === 2) {
                    return 'sticky_header_with_2_params';
                } else if (trueParamsLength === 1) {
                    return `sticky_header_with_1_params ${(showClaimedItemsBar && !settings.show_logo_and_contact) ? 'only_bar' : ''}`;
                } else if (trueParamsLength === 0) {
                    return 'sticky_header_with_0_param';
                }
            } else {
                const trueParamsLength = adjustHeightParams.filter(param => param === true).length;
                if (trueParamsLength === 2) {
                    return 'with_2_params';
                } else if (trueParamsLength === 1) {
                    return `with_1_param ${(showClaimedItemsBar && !settings.show_logo_and_contact) ? 'only_bar' : ''}`;
                } else if (trueParamsLength === 0) {
                    return 'with_0_params';

                }
            }
        };
        const mobileIframeDisplay = () => window.innerWidth <= 768 && window.innerHeight >= 1000;

        return (
            <React.Fragment>
                {this.state.showSurveyModal && (
                    <SurveyModal onCancel={() => this.setState({showSurveyModal: false})}
                                 onSubmit={this.saveSurveyAnswer}
                    />
                )}
                {ready ? <Container fluid
                                    className={`embeddable ${filter && !settings.sticky_header && 'disable-items-scroll'}`}>
                        {showSubmitClaimModal && <div ref={this.submitClaimModalRef}>
                            <SubmitClaimModal
                                sendEventData={this.sendEventData}
                                onSubmit={this.openSubmitModal}
                                onCancel={() => this.setState({showSubmitClaimModal: false})}
                                claimedItemsCount={claimedItems.length} />
                        </div>
                        }
                        {submitModal && <EmbSubmitModal
                            sendEventData={this.sendEventData}
                            recaptcha={settings.recaptcha}
                            claimedItems={claimedItems}
                            closeFn={this.closeSubmitModal}
                            shipping={settings.shipping}
                            ordered_message={settings.ordered_message}
                            card_detail={settings.card_detail}
                            bundle_card_detail={settings.bundle_card_detail}
                            lumber_card_detail={settings.lumber_card_detail}
                            clearCart={() => {
                                this.state.items.content.forEach(s => {
                                    s.request_sanded = undefined;
                                    s.request_surfaced = undefined;
                                });
                                this.props.actions.emptyClaimedItems();
                            }}
                            stripe_api_key={this.state.stripe_api_key}
                            ecommerceConnected={ecommerceConnected}
                            claimEnabled={claimEnabled}
                            stripe_connect_status={stripe_connect_status}
                            square_connect_status={square_connect_status}
                            square_application_id={this.state.square_application_id}
                            square_location_id={this.state.square_location_id}
                            sandbox={this.state.sandbox}
                            client_id={this.state.client_id}
                            client_name={this.props.profile.client_name}
                            search={this.search}
                        />}
                        {!modal && !submitModal && <MobileMenu
                            settings={settings}
                            claimedItems={claimedItems}
                            claimEnabled={claimEnabled}
                            ecommerceConnected={ecommerceConnected}
                            bundle_card_detail={settings.bundle_card_detail}
                            filters={filters}
                            changeSort={this.changeSort}
                            setAvailableInventory={this.setAvailableInventory}
                            getItemRange={this.getItemRange}
                            openSubmitModal={this.openSubmitModal}
                            openFilter={this.openFilter}
                            isActive={this.isActive}
                            items={items}
                            hideFilters={hide_filters}
                            toggleFilter={this.toggleFilter}
                            clientInformation={clientInformation}
                            loading={loading}
                        />}
                        {!modal && !submitModal && <DesktopMenu
                            settings={settings}
                            claimedItems={claimedItems}
                            filters={filters}
                            cardDetail={(filters.type === 'bundles' || filters.type === 'industrial_packs') ? bundle_card_detail : card_detail}
                            items={items}
                            setAvailableInventory={this.setAvailableInventory}
                            getItemRange={this.getItemRange}
                            openSubmitModal={this.openSubmitModal}
                            isActive={this.isActive}
                            changeSort={this.changeSort}
                            loading={loading}
                            clientInformation={clientInformation}
                        />}
                        <Row
                            className={`content-container ${settings.sticky_header ? 'with_sticky_header' : ''} ${settings.show_logo_and_contact && settings.sticky_header ? 'with_logo' : ''} ${item ? 'embedded-item' : ''}`}>
                            {(modal && !submitModal && item) ? item.type === 'Pack'
                                ? <EmbBundleModal
                                    bundle={item}
                                    claimed={this.checkClaimed(item)}
                                    onClaim={this.onClaim}
                                    onUnclaim={this.onUnclaim}
                                    closeFn={this.closeModal}
                                    settings={settings}
                                    ecommerceConnected={ecommerceConnected && materialType.includes('Packs')}
                                    claimEnabled={claimEnabled && materialType.includes('Packs')}
                                    claimedItems={claimedItems}
                                    openSubmitModal={this.openSubmitModal}
                                    emptyClaimedItems={this.props.actions.emptyClaimedItems}
                                />
                                : item.type === 'Industrial Pack' ?
                                    <EmbIndustrialPackModal
                                        industrialPack={item}
                                        claimed={this.checkClaimed(item)}
                                        onClaim={this.onClaim}
                                        onUnclaim={this.onUnclaim}
                                        closeFn={this.closeModal}
                                        settings={settings}
                                        ecommerceConnected={ecommerceConnected && materialType.includes('Industrial Packs')}
                                        claimEnabled={claimEnabled && materialType.includes('Industrial Packs')}
                                        claimedItems={claimedItems}
                                        openSubmitModal={this.openSubmitModal}
                                        emptyClaimedItems={this.props.actions.emptyClaimedItems}
                                    />
                                    : item.type === 'Lumber' ?
                                        <EmbLumberModal
                                            lumber={item}
                                            claimed={this.checkClaimed(item)}
                                            onClaim={this.onClaim}
                                            onUnclaim={this.onUnclaim}
                                            closeFn={this.closeModal}
                                            settings={settings}
                                            ecommerceConnected={ecommerceConnected && materialType.includes('Boards and Beams')}
                                            claimEnabled={claimEnabled && materialType.includes('Boards and Beams')}
                                            claimedItems={claimedItems}
                                            openSubmitModal={this.openSubmitModal}
                                            emptyClaimedItems={this.props.actions.emptyClaimedItems}
                                        />
                                        : <EmbSlabModal
                                            slab={item}
                                            claimed={this.checkClaimed(item)}
                                            onClaim={this.onClaim}
                                            onUnclaim={this.onUnclaim}
                                            closeFn={this.closeModal}
                                            settings={settings}
                                            ecommerceConnected={ecommerceConnected && materialType.includes('Slabs')}
                                            claimEnabled={claimEnabled && materialType.includes('Slabs')}
                                            claimedItems={claimedItems}
                                            openSubmitModal={this.openSubmitModal}
                                            emptyClaimedItems={this.props.actions.emptyClaimedItems}
                                        /> : null}
                            {(!hide_filters && !modal && !submitModal && !mobileIframeDisplay()) && <Col
                                className={`filters right-border p-1 d-xl-block col-sm-6 col-md-4 col-xl-2 ${filter ? 'filter-open' : null} ${adjustFiltersHeight()}`}
                                style={{
                                    backgroundColor: settings.left_container_color ? settings.left_container_color : null,
                                }}>
                                <EmbFilters
                                    itemsExist={items.content.length > 0}
                                    settings={settings}
                                    tree={tree}
                                    categories={categories}
                                    tags={tags}
                                    gradings={gradings}
                                    locations={locations}
                                    characters={characters}
                                    cycles={cycles}
                                    filters={filters}
                                    onFilterSelect={this.onFilterSelect}
                                    onSliderChange={this.onSliderChange}
                                    onItemTypeChange={this.resetFilters}
                                    filter={filter}
                                    itemType={itemType}
                                    loading={loading}
                                    filter_id={this.state.filter_id}
                                    filteredTreesId={this.state.items.filtered_trees_id}
                                    // setSortBy={() => this.setSortBy(this.state.settings.page_order)}
                                />
                            </Col>}
                            {!item && <Col
                                className={filter
                                    ? `display-filters col-sm-6 offset-sm-6 col-md-8 offset-md-4 col-xl-10 offset-xl-2`
                                    : `${hide_filters ? '' : 'display-filters col-xl-10 offset-xl-2'}`}
                                id={'left-side'}
                            >
                                {loading && <div className='loading'>
                                    <Spinner size='lg' animation='border' role='status'>
                                        <span className='sr-only'>Loading...</span>
                                    </Spinner>
                                </div>}
                                {(ready && !hide_filters && !modal && !submitModal && mobileIframeDisplay() && filter) &&
                                    <div style={{height: 800, position: 'relative'}}>
                                        <Col
                                            className={`filters iframeStyles p-1 pl-0 ${adjustFiltersHeight()}`}
                                            style={{
                                                backgroundColor: settings.left_container_color ? settings.left_container_color : null,
                                            }}>
                                            <EmbFilters
                                                itemsExist={items.content.length > 0}
                                                settings={settings}
                                                tree={tree}
                                                categories={categories}
                                                tags={tags}
                                                gradings={gradings}
                                                locations={locations}
                                                characters={characters}
                                                cycles={cycles}
                                                filters={filters}
                                                onFilterSelect={this.onFilterSelect}
                                                onSliderChange={this.onSliderChange}
                                                onItemTypeChange={this.resetFilters}
                                                filter={filter}
                                                itemType={itemType}
                                                loading={loading}
                                                filter_id={this.state.filter_id}
                                                filteredTreesId={this.state.items.filtered_trees_id}
                                                mobileIframeDisplay={mobileIframeDisplay}
                                                // setSortBy={() => this.setSortBy(this.state.settings.page_order)}
                                            />
                                        </Col>
                                    </div>}
                                {!loading && settingsReady && !submitModal && <React.Fragment>
                                    <Row
                                        className={`slab-container row-eq-height ${filter ? 'filter-open' : null}`}
                                        style={{
                                            display: modal ? 'none' : 'grid',
                                            paddingBottom: this.getItemsContainerPaddingBottom(),
                                            backgroundColor: settings.main_container_color
                                                ? settings.main_container_color
                                                : window.getComputedStyle(document.body).getPropertyValue('background-color'),
                                        }}>
                                        {items.content.map((item, i) => filters.type === 'bundles'
                                            ? <EmbBundleItem
                                                sendEventData={this.sendEventData}
                                                bundle={item}
                                                index={i}
                                                settings={settings}
                                                filter={filter}
                                                bundle_card_detail={bundle_card_detail}
                                                ecommerceConnected={ecommerceConnected && materialType.includes('Packs')}
                                                claimEnabled={claimEnabled && materialType.includes('Packs')}
                                                checkClaimed={this.checkClaimed}
                                                onUnclaim={this.onUnclaim}
                                                onClaim={this.onClaim}
                                                onBundleClick={this.onBundleClick}
                                            />
                                            : filters.type === 'industrial_packs' ?
                                                <EmbIndustrialPackItem
                                                    sendEventData={this.sendEventData}
                                                    industrialPack={item}
                                                    index={i}
                                                    settings={settings}
                                                    filter={filter}
                                                    bundle_card_detail={bundle_card_detail}
                                                    ecommerceConnected={ecommerceConnected && materialType.includes('Industrial Packs')}
                                                    claimEnabled={claimEnabled && materialType.includes('Industrial Packs')}
                                                    checkClaimed={this.checkClaimed}
                                                    onUnclaim={this.onUnclaim}
                                                    onClaim={this.onClaim}
                                                    onClick={this.onIndustrialPackClick}
                                                />
                                                : filters.type === 'lumbers' ?
                                                    <EmbLumberItem
                                                        sendEventData={this.sendEventData}
                                                        lumber={item}
                                                        index={i}
                                                        settings={settings}
                                                        filter={filter}
                                                        card_detail={card_detail}
                                                        ecommerceConnected={ecommerceConnected && materialType.includes('Boards and Beams')}
                                                        claimEnabled={claimEnabled && materialType.includes('Boards and Beams')}
                                                        checkClaimed={this.checkClaimed}
                                                        onUnclaim={this.onUnclaim}
                                                        onClaim={this.onClaim}
                                                        onLumberClick={this.onLumberClick}
                                                    />
                                                    : <EmbSlabItem
                                                        sendEventData={this.sendEventData}
                                                        slab={item}
                                                        index={i}
                                                        settings={settings}
                                                        filter={filter}
                                                        card_detail={card_detail}
                                                        ecommerceConnected={ecommerceConnected && materialType.includes('Slabs')}
                                                        claimEnabled={claimEnabled && materialType.includes('Slabs')}
                                                        checkClaimed={this.checkClaimed}
                                                        onUnclaim={this.onUnclaim}
                                                        onClaim={this.onClaim}
                                                        onSlabClick={this.onSlabClick}
                                                    />,
                                        )}
                                    </Row>
                                </React.Fragment>}
                            </Col>}
                        </Row>
                        {pagesCount > 0 && !modal && !submitModal &&
                            <Row
                                className='pagination-footer'
                                style={settings.sticky_footer
                                    ? {
                                        position: 'fixed',
                                        margin: 0,
                                        backgroundColor, color,
                                    }
                                    : {position: 'inherit', backgroundColor, color}}
                            >
                                <Pagination style={{padding: '10px 15px 0 0'}} className='mr-1 mt-1'>
                                    <PaginationItem
                                        onClick={() => (!loading && filters.page !== 1) && this.setState({
                                            filters: {
                                                ...filters,
                                                page: 1,
                                            },
                                        }, this.search)}
                                    >
                                        <PaginationLink style={paginationLinkStyle}>
                                            {'<<'}
                                        </PaginationLink>
                                    </PaginationItem>
                                    {this.getSelectablePages().map(p =>
                                        <PaginationItem
                                            active={p === filters.page}
                                            key={p}
                                            onClick={() => (!loading && p !== filters.page) && this.setState({
                                                filters: {
                                                    ...filters,
                                                    page: p,
                                                },
                                            }, this.search)}
                                        >
                                            <PaginationLink style={{
                                                ...paginationLinkStyle,
                                                backgroundColor: p === filters.page ? color : backgroundColor,
                                                color: p === filters.page ? backgroundColor : color,
                                            }}>
                                                {p}
                                            </PaginationLink>
                                        </PaginationItem>,
                                    )}
                                    <PaginationItem onClick={() =>
                                        (!loading && filters.page !== pagesCount) && this.setState({
                                            filters: {...filters, page: pagesCount},
                                        }, this.search)
                                    }>
                                        <PaginationLink style={paginationLinkStyle}>
                                            {'>>'}
                                        </PaginationLink>
                                    </PaginationItem>
                                </Pagination>
                            </Row>
                        }
                        {claimedItems.length > 0 && !modal && !submitModal &&
                            <ClaimedItemsBar onSubmit={this.openSubmitModal} claimedItems={claimedItems}
                                             ecommerceConnected={ecommerceConnected} claimEnabled={claimEnabled}
                                             settings={settings} sendEventData={this.sendEventData}
                                             cardDetail={(filters.type === 'bundles' || filters.type === 'industrial_packs') ? bundle_card_detail : card_detail} />}
                    </Container> :
                    <div className='loading'>
                        <Spinner size='lg' animation='border' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </Spinner>
                    </div>
                }
            </React.Fragment>
        );
    }
}

EmbPage.contextTypes = {
    router: PropTypes.object,
};

EmbPage.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
    claimedItems: appState.claimedItems,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EmbPage);



// WEBPACK FOOTER //
// ./src/containers/embeddable/EmbPage.js